module.exports = __webpack_public_path__ + "static/media/pic6.cbd2db30.jpg";